import BrowsePage from './BrowsePage'
export default BrowsePage;